import { Component } from "react";
import MyProvider from "./contexts/MyProvider";
import "./custom.css";
import "./styles/main.scss";
import { AdminSwitch } from "./infrastructure/AdminSwitch";
import { DefaultSwitch } from "./infrastructure/DefaultSwitch";

export default class App extends Component {
  static displayName = App.name;

  constructor(props) {
    super(props);
    this.state = {
      mode: "",
    };
  }

  render() {
    this.state.mode = window.__RUNTIME_CONFIG__.Mode;

    if (this.state.mode != "") {
      switch (this.state.mode) {
        case "admin":
          return (
            <MyProvider {...this.state}>
              <AdminSwitch />
            </MyProvider>
          );
        case "portal":
        case "public":
          return (
            <MyProvider {...this.state}>
              <DefaultSwitch />
            </MyProvider>
          );
        default:
          break;
      }
    }
    return "";
  }
}
